import EdgeCreeksideHotels from "./edge-creekside-hotels.pdf";

export const CASE_STUDIES = {
	"edge-creekside-hotels": {
		file: EdgeCreeksideHotels,
		pages:2
	},
};
